import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { useQualification } from '../contexts/QualificationContext';

// Sticky bottom CTA for mobile, appears after the user scrolls past the hero.
// Hidden on desktop (md+).
export default function MobileStickyCTA() {
  const [visible, setVisible] = useState(false);
  const { open } = useQualification();

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;
  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-[60] px-3 pb-[max(env(safe-area-inset-bottom),0.5rem)] pt-2 bg-gradient-to-t from-white via-white/95 to-white/0 pointer-events-none"
      data-testid="mobile-sticky-cta"
    >
      <button
        type="button"
        onClick={() => open('mobile_sticky')}
        className="pointer-events-auto w-full bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] rounded-full shadow-2xl px-5 py-3.5 text-sm font-medium flex items-center justify-center gap-1.5 active:scale-[0.99] transition-transform"
      >
        Scopri il tuo percorso (60s) <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
}
